class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    if (this.content) {
      this.content.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }
    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
  }
  onMouseLeave() {
    this.close();
  }
  // onFocusOut() {
  //   setTimeout(() => {
  //     if (!this.contains(document.activeElement)) this.close();
  //   });
  // }
  onMouseEnter() {
    let tagsAll = this.querySelectorAll('.custom_tags_title')
    let contentAll = this.querySelectorAll('.custom_tags_content')
    if (tagsAll && tagsAll.length > 0) {
      let andfals = Array.from(tagsAll).find(item=>{
        return item.classList.contains('tags_active')
      })
      if (!andfals){
        tagsAll[0].classList.add('tags_active');
      }else {
        
      }
      
    }
    if (contentAll && contentAll.length > 0) {
      let andfals = Array.from(contentAll).find(item=>{
        return item.classList.contains('content_active')
      })
      if (!andfals){
        contentAll[0].classList.add('content_active')
      }else {
        
      }
    }
    tagsAll.forEach(item=>{
        item.addEventListener('mouseenter',(e)=>{
            tagsAll.forEach(hiddenItem=>hiddenItem.classList.remove('tags_active'))
            e.target.classList.add('tags_active')
            contentAll.forEach(contentItem=>{
                if(contentItem.dataset.tagstitle == e.target.dataset.tagstitle){
                    contentItem.classList.add('content_active')
                }else{
                    contentItem.classList.remove('content_active')
                }
            })
        })
    })
    let numAll = document.querySelectorAll('details');
    let megaDetails = [];
    numAll.forEach((item) => {
      // if (item.classList.contains('mega_menu_url')) {
      if (item.classList.contains('mega-menu')) {
        megaDetails.push(item);
      }
    });
    megaDetails.forEach(eitem=>{
      eitem.removeAttribute('open');
    })
    this.mainDetailsToggle.setAttribute('open', true);
    this.onToggle();
  }
  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);